'use strict';

/*global BasicBarcodes*/
/*global app*/
/*global services*/
/*global sprintf*/
/*global blockElement*/
/*global unBlockElement*/
/*global resSuccess*/

function BarcodesReceiptArticles(containerId) {
  BasicBarcodes.call(this, containerId);
}

BarcodesReceiptArticles.prototype = $.extend({}, BasicBarcodes.prototype, {
  constructor: 'BarcodesReceiptArticles',

  //----------------------------------------------------------------------------

  getHandlingUnitRIDs: function getHandlingUnitRIDs() {
    var _this = this;

    var ar = [];
    _this.$container.find('.handling_unit--RID').each(function () {
      ar.push($(this).val());
    });

    return ar;
  },

  onAfterAddItem: function onAfterAddItem($row) {
    var _this = this;

    var barcode = $row.find('input[name$="[Barcode]"]').val();

    blockElement(_this.$container);
    services.get('barcode-service').findArticle(barcode, 0, function (res, resData) {
      unBlockElement(_this.$container);

      if (res !== resSuccess) {
        return app.viewErrorMessage(app.t('barcode.unknown'), function () {
          _this.removeItem($row);
        });
      }

      var article = resData;
      $row.find('input[name$="[RID]"]').val(resData.Id);

      blockElement(_this.$container);
      services.get('article-service').getStockQuantity(resData.Id, { HandlingUnitRIDs: _this.getHandlingUnitRIDs() }, function (res, resData) {
        unBlockElement(_this.$container);

        if (res !== resSuccess) {
          return _this.removeItem($row);
        }

        var description = article.Abbr + ' | ' + article.Name + ' (<strong>'  + resData.Available + ' ' + resData.Unit + '</strong>)';
        $row.find('.barcodes-items__barcode-description').html(description);
        $row.find('input[name$="[Description]"]').val(description);

        if (resData.Assigned > 0 && resData.Available > 0) {
          return app.viewErrorMessage(sprintf(app.t('receipt_transfer.exists_article_assigned'), resData.Assigned + ' ' + resData.Unit, resData.Available + ' ' + resData.Unit));
        }

        if (resData.Assigned > 0 && resData.Available <= 0) {
          return app.viewErrorMessage(sprintf(app.t('receipt_transfer.exists_article_assigned_no_available'), resData.Assigned + ' ' + resData.Unit), function () {
            _this.removeItem($row);
          });
        }

        if (resData.Available <= 0) {
          return app.viewErrorMessage(app.t('receipt_transfer.no_article_available'), function () {
            _this.removeItem($row);
          });
        }
      });
    });

    return _this;
  },

  isFormValid: function isFormValid() {
    //nevalidujeme, nepotrebujeme mit polozky

    return true;
  },

  //----------------------------------------------------------------------------

});
